import { render, staticRenderFns } from "./ICheckbox.vue?vue&type=template&id=20e1e26a&"
import script from "./ICheckbox.vue?vue&type=script&lang=ts&"
export * from "./ICheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports